<template>
  <Card :title="$t('crm-setting.appointment.list')" containerClass="mb-5">
    <template #cardToolbar>
      <div class="d-flex justify-content-end align-items-center">
        <div>
          <Button type="new" v-if="$can(abilities.CREATE_APPOINTMENT_TYPE)" btn-class="me-3 btn-sm" btn-text="button.create"  @click="openCreateModal" ></Button>
        </div>
      </div>
    </template>
    <template #cardBody>
      <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_appointment_type" style="margin-top: 13px !important; cursor:pointer">
        <thead style="background-color: #F2F3F4;">
        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
          <th class=" px-4 ">{{$t("crm-setting.appointment.type")}}</th>
          <th>{{$t("actions")}}</th>
        </tr>
        </thead>
      </table>
    </template>
  </Card>

  <Update :form="formEdit" @load="reloadDatatable" id="updateAppointmentTypeModal"  :isEdit="true" />
  <Create @load="reloadDatatable" id="createAppointmentTypeModal" />
</template>

<script setup>

import Update from "@/Modules/CRM/components/Modals/AppointmentType/CreateAppointmentType.vue";
import {ref,onMounted,watch,nextTick} from "vue";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import Ls from "@/services/ls";
import { useI18n } from 'vue-i18n'
import { useLocales } from '@/composables/locales';
import Button from "@/components/Button.vue";
import Create from "@/Modules/CRM/components/Modals/AppointmentType/CreateAppointmentType.vue";
import Card from "@/Modules/CRM/components/Card";
import {Theme} from "@/composables/theming";
import {useSwal} from "@/composables/useSwal";
import abilities from "@/composables/abilities";
import {useHasAbility} from "@/composables/hasAbility";

const table = ref(null)
const formEdit = ref({})
const store = useStore()

const { t } = useI18n({ useScope: 'global' })
const {locale, datatableLocaleUrl} = useLocales()
const {showSwal} = useSwal()
const { can } = useHasAbility()

function openCreateModal(){
$('#createAppointmentTypeModal').modal('toggle')
}

function fetchDatas() {

    const AUTH_TOKEN = Ls.get('auth.token')
    const pageLimit = Ls.get('pageLength')


    table.value = $("#kt_datatable_appointment_type").DataTable({
      destroy : true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: pageLimit ||  5,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 0, 'desc']],
      ajax: {
        url: BASE_URL+"/get/appointmentType/datatable",
        type: "GET",
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
          },
        data:  function ( d ) {

        }
      },
      columns: [{ data: "name" }, { data: "Actions", responsivePriority: -1 }],

      columnDefs: [
        {
          targets: -2,
          order: "desc",
          render: function (t, a, e, l) {
            return '<span class="nameRow'+ l.row +'">' + t + "</span>";
          },
        },
        {
          width: "16%",
          targets: -1,
          "className": "dt-center",
          title: "Actions",
          orderable: !1,
          render: (t, a, e, l) => {
            let render = '';
            if(can(abilities.UPDATE_APPOINTMENT_TYPE)) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-name="${e.name}" class="btn btn-sm btn-clean btn-icon edit_btn" title="${i18n.global.t('button.edit')}"><i data-row="${l.row}" data-id="${e.id}" data-name="${e.name}" class="fas fa-edit fs-2"  style="color: ${Theme.gray}" style="color: ${Theme.gray}"></i></a>`;
            if(can(abilities.DELETE_APPOINTMENT_TYPE)) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon delete_btn" title="${i18n.global.t('button.delete')}"><i data-row="${l.row}" data-id="${e.id}" class="fas fa-trash fs-2" style="color: ${Theme.gray}" style="color: ${Theme.gray}"></i></a>`;
            return render;
          },
        },

      ],
      language: {
        url:  datatableLocaleUrl.value
      }
    });

    $(document).on("click", "#kt_datatable_appointment_type .edit_btn", (e) => {
      formEdit.value.id = e.target.getAttribute('data-id')
      formEdit.value.name = e.target.getAttribute('data-name')
      $('#updateAppointmentTypeModal').modal('toggle')
    });
}

function reloadDatatable(){
table.value.ajax.reload()
}

$(document).on("click", "#kt_datatable_appointment_type .delete_btn", (e) => {
deleteReason(e.target.getAttribute('data-id'))
});


async function deleteReason(id){
showSwal(
    t('swal.title'),
    t('swal.reason_deleting')
).then( async (result) => {
  if (result.value) {
    try {
      await store.dispatch('appointmentTypes/deleteAppointmentType', id)
      reloadDatatable()
      window.toastr.success(t('notification.appointment_deleted'))
    } catch (e) {
    }
  }
});
}

watch(() => locale.value, () => {
nextTick(()=>   fetchDatas())

})

onMounted(() => {
fetchDatas()
})

</script>